import React, {useEffect, useState} from "react";
import QTextBox from "../../../../common/components/QTextBox";
import QDate from "../../../../common/components/QDate/QDate";
import QSelect from "../../../../common/components/QSelect";
import {Col, Container, Row} from "reactstrap";
import {ProductInterface} from "../../../../interfaces/private/ProductInterface";
import ProductApi from "../../../../common/api/functions/Product";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import QButton from "../../../../common/components/QButton";
import QModal from "../../../../common/components/QModal";
import {useTranslation} from "react-i18next";

interface Props {
    open: number, // open > 0 show,
    setOpen: Function,
    onSaveSuccess?: () => void,
}

const BodyProductDetailComponent: React.FC<Props> = ({ setOpen, open, onSaveSuccess }) => {
    const { t } = useTranslation();
    const id = open;
    const [product, setProduct] = useState<ProductInterface | any>({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [weight, setWeight] = useState<string>('');

    useEffect(() => {
        if (id > 0) {
            ProductApi.getDetail(id).then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    const data = response?.data?.data || {};
                    await setProduct(data);
                    setWeight(data.inventory_netWeight != null && data.inventory_netWeight !== '' ? String(data.inventory_netWeight) : '');
                    await setLoading(false);
                }
            });
        }
        return () => {
            setLoading(true);
        };
    }, [id]);

    useEffect(() => {
        if (product?.inventory_netWeight != null && product.inventory_netWeight !== '') {
            setWeight(String(product.inventory_netWeight));
        } else {
            setWeight('');
        }
    }, [product?.inventory_netWeight]);

    const handleSaveWeight = async () => {
        if (!id || !product?.id) return;
        const num = weight === '' ? null : parseFloat(weight);
        if (weight !== '' && isNaN(num as number)) return;
        try {
            setSaving(true);
            await ProductApi.update(id, { inventory_netWeight: num ?? undefined });
            setProduct((prev: any) => ({ ...prev, inventory_netWeight: num }));
            onSaveSuccess?.();
            setOpen(0);
        } finally {
            setSaving(false);
        }
    };

    return (
        <React.Fragment>
            <QModal
                loading={loading}
                open={open > 0}
                setOpen={() => { setOpen(0) }}
                headerContent={t("product.detail.title")}
                className={'modal-md-zp'}
                bodyContent={(
                    <React.Fragment>
                        <Container>
                            <Row>
                                <Col>
                                    <QTextBox label={t("product.detail.sku")} disabled={true} value={product.productNumber} onChange={() => {}} className="form-control-zp bg-light text-secondary" />
                                </Col>
                                <Col>
                                    <QTextBox label={t("product.detail.name")} disabled={true} value={product.name} onChange={() => {}} className="form-control-zp bg-light text-secondary" />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <QTextBox label={t("product.detail.salePrice")} disabled={true} value={product.salesPrice} onChange={() => {}} className="form-control-zp bg-light text-secondary" />
                                </Col>
                                <Col>
                                    <QTextBox label={t("product.detail.costPrice")} disabled={true} value={product.costPrice} onChange={() => {}} className="form-control-zp bg-light text-secondary" />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <QTextBox label={t("product.detail.group")} disabled={true} value={product.productGroup_name} onChange={() => {}} className="form-control-zp bg-light text-secondary" />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="mb-3">
                                        <label className="form-label">{t("product.detail.weight")}</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="number"
                                                step="0.01"
                                                className="form-control form-control-zp flex-grow-1"
                                                value={weight}
                                                onChange={(e) => setWeight(e.target.value)}
                                            />
                                            <span className="ms-2 text-muted">Kg</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col />
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>
                                        <QButton
                                            type={'default'}
                                            onClick={() => { setOpen(0); }}
                                            content={t("common.button.cancel")}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary d-inline-flex align-items-center"
                                            disabled={saving}
                                            onClick={handleSaveWeight}
                                        >
                                            {saving && (
                                                <span className="spinner-border spinner-border-sm me-1" style={{ width: '0.75rem', height: '0.75rem', borderWidth: '0.15em' }} role="status" aria-hidden="true" />
                                            )}
                                            <span>{saving ? t("common.button.saving") || 'Saving...' : t("common.button.save") || 'Save'}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </React.Fragment>
                )}
            />
        </React.Fragment>
    )
}

export default BodyProductDetailComponent
